var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBookSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.908c0 .71-.72 1.2-1.37.93-1.86-.78-4.17-1.46-5.81-1.68l-.31-.04c-.97-.12-1.76-1.01-1.76-1.98V5.248c0-1.2.97-2.17 2.17-2.17h.07c1.88.16 4.65 1.04 6.48 2.03a1 1 0 0 1 .53.89v13.91z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.77 3.078c-.24.02-.5.05-.77.1-1.23.2-2.69.62-4 1.14-.62.25-1.2.52-1.71.79-.33.18-.54.52-.54.89v13.91c0 .71.72 1.2 1.37.93 1.86-.78 4.17-1.46 5.81-1.68l.31-.04c.97-.12 1.76-1.01 1.76-1.98V5.248c0-1.2-.97-2.17-2.17-2.17h-.06zm-1.12 11.02-1.06-.59a.49.49 0 0 0-.41 0l-1.06.59c-.34.19-.62.02-.62-.37v-3.07c0-.46.38-.84.84-.84h2.1c.46 0 .84.38.84.84v3.07h-.01c0 .39-.28.56-.62.37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBookSaved);
export default __webpack_public_path__ + "static/media/vuesax-bold-book-saved.385b19b5bd78385bc8be7f59868099b2.svg";
export { ForwardRef as ReactComponent };